<script>
    import Footer from '../landing_page/footer.svelte';
    import Navbar from '../navbar/navbar.svelte';
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    import {fundamentalForm, CorporateInnovation, BlockchainAccelerators, CorporateAccelerators} from './apply_data';
    import SecondFormFundamental from './second_form_fundamental.svelte';
    import SubmitForm from './submit_form.svelte';
    import TableForm from './table_form.svelte';
    import ThirdFormFundamental from './third_form_fundamental.svelte';
    import {getContext} from 'svelte';
    import {HeroForm} from '../store.js';
    let getSession;
    let CheckBox;
    let displayDiv;
    let displayDiv2;
    let tableData;
    const {title} = rpcjs.props;
    title.set('Apply | Exective');
    const {url} = getContext('APP');
    const formNo = Object.fromEntries(new URLSearchParams($url.search));
    if (HeroForm.get() == undefined) {
        HeroForm.update((n)=> n={session: '', name: '', email: '', country: '', countryCode: '', city: '', phoneNumber: '',
            dateOfBirth: '', gender: '', technicalSkill: '', englishAbility: '', industry: '', industryOther: '',
            business: '', visa: '', aid: '', referalName: '', hearAbout: '', hearAboutOthers: '',
            startup: '', aboutYourSelf: '', portfolioURL: '', buildingPlan: '', travelBudget: '',
            buildingWeeks: '', invitedtoProgram: '', ackowledged: ''});
    } else {
        getSession=HeroForm.get().session;
    }
    $: if (HeroForm.get() != undefined) {
        HeroForm.update((n)=> n={session: getSession, name: HeroForm.get().name, email: HeroForm.get().email,
            country: HeroForm.get().country, countryCode: HeroForm.get().countryCode,
            city: HeroForm.get().city, phoneNumber: HeroForm.get().phoneNumber, dateOfBirth: HeroForm.get().dateOfBirth,
            gender: HeroForm.get().gender,
            technicalSkill: HeroForm.get().technicalSkill, englishAbility: HeroForm.get().englishAbility,
            industry: HeroForm.get().industry, industryOther: HeroForm.get().industryOther,
            business: HeroForm.get().business, visa: HeroForm.get().visa,
            aid: HeroForm.get().aid, referalName: HeroForm.get().referalName,
            hearAbout: HeroForm.get().hearAbout, hearAboutOthers: HeroForm.get().hearAboutOthers,
            startup: HeroForm.get().startup,
            aboutYourSelf: HeroForm.get().aboutYourSelf,
            portfolioURL: HeroForm.get().portfolioURL, buildingPlan: HeroForm.get().buildingPlan,
            travelBudget: HeroForm.get().travelBudget, buildingWeeks: HeroForm.get().buildingWeeks,
            invitedtoProgram: HeroForm.get().invitedtoProgram, ackowledged: HeroForm.get().ackowledged});
    }
    if ( formNo.name === 'FundamentalsOfEntrepreneurship') {
        tableData = fundamentalForm;
    } else if (formNo.name === 'CorporateInnovation') {
        tableData = CorporateInnovation;
    } else if (formNo.name === 'Blockchain') {
        tableData = BlockchainAccelerators;
    } else if (formNo.name === 'CorporateAccelerator') {
        tableData = CorporateAccelerators;
    }
    /**
     *
     * @param {string}object
     */
    function saveData() {
        if (formNo.name === 'FundamentalsOfEntrepreneurship') {
            location.href='/apply?name=FundamentalsOfEntrepreneurship&FormNo=secondform';
        } else if (formNo.name === 'CorporateInnovation') {
            location.href='/apply?name=CorporateInnovation&FormNo=secondform';
        } else if (formNo.name === 'Blockchain') {
            location.href='/apply?name=Blockchain&FormNo=secondform';
        } else if (formNo.name === 'CorporateAccelerator') {
            location.href='/apply?name=CorporateAccelerator&FormNo=secondform';
        }
    }
    /**
     *
     *
     */
    function goBack() {
        location.href='/applyProgram';
    }
    // <!-- Google Tag Manager -->
(function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <div class="desktop">
        <Navbar />
    </div>
    <div class="mobile back-img">
        <NavbarMenu backgroundColor="transparent" stroke="black" />
    </div>
    <div class="desktop">
        <div class="heading">
            <p>Apply to DraperU</p>
        </div>
        <div class="pre">
            <p>go from an idea to a product ready to pitch to investors</p>
        </div>
        {#if formNo.FormNo === 'firstform'}
            <div>
                <div class="back-div">
                    <div>
                        <div class="process">
                            <p>Process</p>
                        </div>
                        <div class="process_x">
                            <p>
                                Our Application is a 4 step process, where you
                                provied the requierd information. This form
                                costs $5 for submission.
                            </p>
                        </div>
                    </div>

                    <ul style="list-style: none;">
                        {#each Array(3) as _, i}
                            <li class="vl" />
                        {/each}
                    </ul>

                    <div class="front-div">
                        <div style="margin-top: -2.712vw;">
                            <div class="back-arrow" on:click={() => ( goBack())}>
                                <img src="images/apply/back_arrow.svg" alt="">
                            </div>
                            <div>
                                <p class="session">Session</p>
                            </div>
                            <div style="margin-top:1.257vw;">
                                <TableForm detail={tableData} bind:getSession bind:CheckBox/>
                            </div>
                            <div class="fields-alert"  bind:this={displayDiv}>
                                <p>Please check the box if you want to proceed</p>
                            </div>
                            <div style="margin-left: 5vw; margin-top: 5vw;">
                                <button
                                    style=" background-color: rgba(60, 116, 192, 1);
                                                border-radius: 1.984vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 1.190vw;"
                                    on:click={() => {
                                         if (CheckBox == false) {
                                                saveData();
                                        } else {
                                            displayDiv.style.display = 'block';
                                        }
                                    }}>Next</button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {:else if formNo.FormNo === 'secondform'}
            <SecondFormFundamental/>
        {:else if formNo.FormNo === 'thirdform'}
            <ThirdFormFundamental/>
        {:else if formNo.FormNo === 'submitform'}
            <ThirdFormFundamental />
            <SubmitForm />
        {/if}
    </div>
    <div class="mobile">
        <div class="heading-mobile">
            <p>Apply to <br /> DraperU</p>
        </div>
        {#if formNo.FormNo === 'firstform'}
            <div class="back-div-mobile">
                <div style="position: absolute;">
                    <p class="process-mobile">Process</p>

                    <p class="process_x-mobile">
                        Our Application is a 4 step process, where you provied
                        the requierd information. This form costs $5 for
                        submission.
                    </p>
                </div>

                <div style="padding-top: 33vw;">
                    <ul
                        style="list-style: none; display: flex; gap: 24.5vw;width: 75vw;padding-left: 15vw;">
                        {#each Array(3) as _, i}
                            <li class="vl-mobile" />
                        {/each}
                    </ul>
                </div>

                <div class="front-div-mobile">
                    <div>
                        <div style="margin-top:1.257vw;">
                            <TableForm detail={tableData} bind:getSession bind:CheckBox/>
                        </div>
                    </div>
                    <div class="fields-alert"  bind:this={displayDiv2}>
                        <p>Please check the box if you want to proceed</p>
                    </div>
                    <div style="margin-top: 5vw;justify-content: center; display: flex; gap: 4.673vw;">
                        <button
                            style=" background-color: rgba(60, 116, 192, 1);
                        border-radius: 6.069vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 3.889vw;"
                            on:click={() => {
                                if (CheckBox == false) {
                                    saveData();
                            } else {
                                displayDiv2.style.display = 'block';
                            }
                        }}>Next</button>
                         <div class="back-arrow-mob" on:click={() => ( goBack())}>
                            <img src="images/apply/back_button.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        {:else if formNo.FormNo === 'secondform'}
            <SecondFormFundamental/>
        {:else if formNo.FormNo === 'thirdform'}
            <ThirdFormFundamental/>
        {:else if formNo.FormNo === 'submitform'}
            <ThirdFormFundamental />
            <SubmitForm />
        {/if}
    </div>
    <div style="margin-top: -1vw;">
        <Footer />
    </div>
  
</section>

<style>
    .back-arrow{
        width: 1.72vw;
        height: 0.926vw;
        margin-left: 2.646vw;
        margin-bottom: -2.7vw;
        margin-top: 4.323vw;
        cursor: pointer;
    }
    .back-arrow img{
        width: 100%;
        height: 100%;
    }
     .fields-alert{
        color: red;
        font-size: 0.6vw;
        position: absolute;
        margin-left: 5.1vw;
        margin-top: 2vw;
        display: none;
    }
    .heading {
        font-size: 3.307vw;
        font-weight: 600;
        text-align: center;
        margin-top: 14.815vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .pre {
        font-size: 1.323vw;
    color: #00204b;
    text-align: center;
    margin-bottom: 3.968vw;
    }
    .back-div {
        position: relative;
        height: 44.812vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 2vw;
        display: flex;
    }
    .front-div {
        position: absolute;
    width: 100%;
    height: 27.579vw;
    background: #ffffff;
    border-bottom-left-radius: 2vw;
    border-bottom-right-radius: 2vw;
    left: 22.25vw;
    bottom: 18.25vw;
    }
    .session {
        font-weight: 700;
        margin-top: 4.984vw;
        color: rgba(0, 32, 75, 1);
        margin-left: 4.96vw;
        font-size: 1.058vw;
    }
    .process {
        font-size: 1.984vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 3vw;
        margin-top: 4.497vw;
    }
    .process_x {
        width: 15.013vw;
        font-size: 0.926vw;
        color: rgb(255 255 255);
        font-weight: 300;
        margin-left: 3vw;
    }
    .vl {
        margin-top: 1.984vw;
        border-radius: 0.5vw;
        width: 0.463vw;
        border-left: 0.5vw solid rgba(60, 116, 192, 1);
        height: 5.82vw;
        opacity: 0.3;
        margin-left: 0vw;
    }
    .vl:nth-child(1) {
        border-left: 0.5vw solid white;
        opacity: 100;
    }
    .heading-mobile {
        font-size: 8.333vw;
        font-weight: 600;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        padding-top: 34.167vw;
    }
    .back-div-mobile {
        position: relative;
        height: 148vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 8vw;
        border-top-right-radius: 8vw;
        margin-bottom: -0.2vw;
    }
    .process-mobile {
        font-size: 5.556vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 7.222vw;
        padding-top: 9.167vw;
    }
    .process_x-mobile {
        width: 73.889vw;
        font-size: 3.056vw;
        color: rgb(255 255 255);
        margin-left: 7.222vw;
    }
    .vl-mobile {
        border-radius: 0.5vw;
        border-left: 1.3vw solid rgba(60, 116, 192, 1);
        height: 15.460999999999999vw;
        opacity: 0.3;
        margin-left: 0vw;
        transform: rotate(90deg);
    }
    .vl-mobile:nth-child(1) {
        border-left: 1.3vw solid white;
        opacity: 100;
    }
    .front-div-mobile {
        position: absolute;
        width: 92.778vw;
        background: #ffffff;
        border-top-left-radius: 4.5vw;
        border-bottom-left-radius: 4.5vw;
        left: 7.222vw;
        padding-bottom: 5vw;
        top: 45vw;
    }
    .desktop {
        display: block;
        width: 100%;
        overflow: hidden;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .back-arrow-mob{
            width: 10.047vw;
            height: 7.243vw;
        }
        .back-arrow-mob img{
            width: 100%;
            height: 100%;
        }
        .fields-alert{
            font-size: 2vw;
            margin-top: -7vw;
        }
    }
</style>
